import { Resource } from '../core/state/resource/models';
import { customAlphabet } from 'nanoid';
import { DateTime } from 'luxon';
import { environment } from '../../..//environments/environment';

export function getResourcePath(resource: Resource | string) {
  if (typeof resource === 'string') {
    return resource;
  }
  return resource.path;
}

export function generateRandomShortId() {
  const alphabet =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const nanoid = customAlphabet(alphabet, 10);
  return seperateText(nanoid(), '-');
}

// seperator for 10 char ids
const seperateText = (input: string, seperator: string) => {
  const start = input.slice(0, 3);
  const middle = input.slice(3, 7);
  const end = input.slice(-3);
  return start + seperator + middle + seperator + end;
};

export const createDateWithTimezoneAndTime = (
  date: Date | string,
  timeZone = 'Asia/Colombo',
  startTime = '00:00',
): Date => {
  return DateTime.fromJSDate(new Date(date))
    .setZone(timeZone)
    .set({
      hour: Number.parseInt(startTime.split(':')[0]),
      minute: Number.parseInt(startTime.split(':')[1]),
      second: 0,
      millisecond: 0,
    })
    .toJSDate();
};

export function formatSocialLink(
  url: string | undefined,
  type: 'whatsapp' | 'telegram',
): string {
  if (!url || !url.trim()) return '';
  const trimmed = url.trim();

  if (type === 'whatsapp') {
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      return trimmed;
    }
    if (
      trimmed.startsWith('chat.whatsapp.com') ||
      trimmed.startsWith('wa.me')
    ) {
      return `https://${trimmed}`;
    }
    const sanitizedNum = trimmed.replace(/[^0-9]/g, '');
    if (sanitizedNum) {
      return `https://wa.me/${sanitizedNum}`;
    }
    return `https://${trimmed}`;
  }

  if (type === 'telegram') {
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      return trimmed;
    }
    if (trimmed.startsWith('@')) {
      return `https://t.me/${trimmed.substring(1)}`;
    }
    if (trimmed.startsWith('t.me')) {
      return `https://${trimmed}`;
    }
    return `https://t.me/${trimmed}`;
  }

  return trimmed;
}

export const isBackendApiRequest = (url: string): boolean => {
  if (!url) {
    return false;
  }
  if (environment.host && url.startsWith(environment.host)) {
    return true;
  }
  return url.startsWith('/api') || url.startsWith('api/');
};
